module.exports = __webpack_public_path__ + "img/close.18445307.svg";